<template>
  <div :style="'padding 10px;position: relative;width: 100%;min-height: 100%;overflow: hidden;' + getSimulatorBodyStyle(ui.background)">
    <ui-loading v-if="ui.loading.is_open === 1" :loading="ui.loading" :images="images"></ui-loading>
    <div v-if="!loadding" style="width: 100%;height: 100%;">
      <ui-element :project-id="projectId" :lucking="lucking" :product-list="productList" :member="member" :apiroot="apiroot" :ui="ui"></ui-element>
      <div v-if="lucking.type === 'grid'" :style="getSubjectStyle()">
        <lucking-grid ref="lucking-grid" :run-lucking="runLucking" :lucking="lucking" :product-list="productList" :icon-list="iconList"></lucking-grid>
      </div>
      <div v-if="lucking.type === 'slot_machine'" :style="getSubjectStyle()">
        <lucking-slot-machine ref="lucking-slot_machine" :run-lucking="runLucking" :lucking="lucking" :product-list="productList" :icon-list="iconList"></lucking-slot-machine>
      </div>
      <ui-music ref="music" v-if="ui.music.is_open === 1" :music="ui.music"></ui-music>
    </div>
    <lucking-win ref="lucking-win" :project-id="projectId" :lucking="lucking" :apiroot="apiroot" :member="member" :product-list="productList" :ui="ui"></lucking-win>
  </div>
</template>
<script>
import '@/assets/css/lucking.css'
import { getSimulatorBodyStyle, getSimulatorBodyItem, getLuckingIconList } from '@/libs/tool'
import { UiLoading, UiElement, UiMusic } from './components/ui'
import { LuckingWin, LuckingGrid, LuckingSlotMachine } from './components/lucking'

var rootUrl = process.env.NODE_ENV === 'development' ? 'http://local.share.com' : ''
export default {
  name: 'app',
  components: {
    UiLoading,
    UiElement,
    UiMusic,
    LuckingWin,
    LuckingSlotMachine,
    LuckingGrid
  },
  data () {
    return {
      iconList: getLuckingIconList(),
      apiroot: rootUrl,
      loadding: true,
      projectId: null,
      projectUid: null,
      images: [],
      project: {},
      authorize: {},
      formwork: '',
      formwork_attr: '',
      member: {},
      ui: {
        loading: {},
        background: {}
      },
      lucking: {
        type: null,
        location: {
          box_name: '',
          list: {}
        },
        probability: {
          daily_frequency: 1,
          list: {}
        }
      },
      productList: {},
      posterUrl: ''
    }
  },
  watch: {
  },
  methods: {
    inArray (search, array) {
      for (var i in array) {
        if (array[i] === search) {
          return true
        }
      }
      return false
    },
    winLucking (code, pId, receivingObj) {
      this.$refs['lucking-win'].winLucking(code, pId, receivingObj)
    },
    getLucking (code) {
      var postData = {}
      postData['sign'] = 'lucking'
      postData['action'] = 'getLuckingCode'
      postData['project_id'] = this.projectId
      postData['data'] = {}
      postData['data']['code'] = code
      this.$http.post(this.apiroot + '/open/action', postData).then((response) => {
        if (response.data.code === 1) {
          if (response.data.data.status === 1) {
            this.$refs['lucking-' + this.lucking.type].setLucking(response.data.data.product_id)
            setTimeout(() => {
              this.winLucking(code, response.data.data.product_id, response.data.data.receiving_obj)
            }, 1234)
          } else {
            setTimeout(() => {
              this.getLucking(code)
            }, 1234)
          }
        }
      })
    },
    runLucking () {
      var postData = {}
      postData['sign'] = 'lucking'
      postData['action'] = 'runLucking'
      postData['project_id'] = this.projectId
      postData['data'] = {}
      postData['data']['project_uri_id'] = this.projectUid
      this.$http.post(this.apiroot + '/open/action', postData).then((response) => {
        if (response.data.code === 1) {
          this.getLucking(response.data.data.code)
        } else {
          this.$Message.error('抽奖失败' + (response.data.message ? '，' + response.data.message + '。' : '。'))
          this.$refs['lucking-' + this.lucking.type].setLucking(null)
        }
      })
    },
    getSubjectStyle () {
      var style = 'text-align: center;'
      style += 'position: ' + this.ui.subject.position + ';'
      style += this.ui.subject.size_type + ': ' + this.ui.subject.size_value + ';'
      style += this.ui.subject.y_axis_type + ': ' + this.ui.subject.y_axis_value + ';'
      style += this.ui.subject.x_axis_type + ': ' + this.ui.subject.x_axis_value + ';'
      if (this.ui.subject.margin) {
        style += 'margin: ' + this.ui.subject.margin + ';'
      }
      if (this.ui.subject.margin) {
        style += 'margin: ' + this.ui.subject.margin + ';'
      }
      if (this.ui.subject.padding) {
        style += 'padding: ' + this.ui.subject.padding + ';'
      }
      if (this.ui.subject.style) {
        style += this.ui.subject.style
      }
      style += 'z-index: 90;'
      return style
    },
    getSimulatorBodyStyle (background) {
      return getSimulatorBodyStyle(background)
    },
    getSimulatorBodyItem (obj) {
      return getSimulatorBodyItem(obj)
    },
    getProject () {
      var timestamp = Date.parse(new Date())
      this.$http.get(this.apiroot + '/open/project?id=' + this.projectId + '&puid=' + this.projectUid + '&' + timestamp).then((response) => {
        this.loadding = false
        this.$set(this, 'project', response.data.data.project)
        this.$set(this, 'authorize', response.data.data.authorize)
        this.$set(this, 'formwork', response.data.data.formwork)
        this.$set(this, 'formwork_attr', response.data.data.formwork_attr)
        this.$set(this, 'member', response.data.data.member)
        this.$set(this, 'ui', response.data.data.ui)
        this.$set(this, 'lucking', response.data.data.lucking)
        this.$set(this, 'productList', response.data.data.product_list)
        this.$set(this, 'images', response.data.data.images)
        if (this.authorize) {
          this.init(this.authorize.id)
        }
        this.$Spin.hide()
      })
    },
    init (authorizeId) {
      if (window.kkWeChat) {
        var project = this.project
        var url = this.project.url + '?shareId=' + (this.member.id ? this.member.id : 'none')
        var me = this
        window.kkWeChat.init(authorizeId, function () {
          window.kkWeChat.setShare(url, project, function (doing, status, res) {
            me.triggerShare(doing, status, res)
          })
        })
      }
    },
    triggerShare (doing, status, res) {
      var postData = {}
      postData['UID'] = this.member['UID']
      postData['id'] = this.projectId
      postData['pu_id'] = this.projectUid
      postData['status'] = status === 1 ? 200 : 209
      this.$http.post(this.apiroot + '/open/share', postData).then((response) => {
        if (response.data.code) {
          if (status === 1) {
            this.$Message.success('分享成功')
          } else {
            this.$Message.info('取消分享')
          }
        }
      })
    }
  },
  mounted () {
    this.projectId = window.pid
    if (this.projectId === '{{ $projectId }}') {
      this.projectId = '69'
    }
    this.projectUid = window.puid
    if (this.projectUid === '{{ $projectUid }}') {
      this.projectUid = '93'
    }
    this.$Spin.show()
    this.getProject()
  }
}
</script>
<style>
.w-100 { width: 100px; }
</style>



// WEBPACK FOOTER //
// src/App.vue